export function loadPopulus() {
  const script = document.createElement("script");
  script.src = "https://cdn.populus-media.net/popcorn/v5/index.js?mode=api";
  script.id = "populusFramework";
  document.body.appendChild(script);
}
